define(['jquery'], function expandable($) {

    var $html = $('html'),
        $body = $('body'),
        selector = '.expandable';

    var bind,
        getAllElements,
        collapseAll,
        isExpanded,
        isDisabled,
        expand,
        collapse;

    var onExpandableClick,
        onHTMLClick,
        onMoreClick;

    getAllElements = function getAllElements() {
        return $(selector);
    };

    collapseAll = function collapseAll(options) {
        options = Object(options);

        var elements = getAllElements();

        if (options.hasOwnProperty('not')) {
            elements = elements.not(options.not);
        }

        return elements.removeClass('expanded');
    };

    isExpanded = function isExpanded($element) {
        return $element.hasClass('expanded');
    };

    isDisabled = function isDisabled($element) {
        return $element.hasClass('disabled');
    };

    expand = function expand($element) {
        return $element.addClass('expanded');
    };

    collapse = function collapse($element) {
        return $element.removeClass('expanded');
    };

    onExpandableClick = function onExpandableClick(event) {

        var $element = $(this);
        var $more = $element.children('.more');
        var $target = $(event.target);
        $body.removeClass('no-scroll');

        if($more.is($target).length || $more.has($target).length) {
            return true;
        }

        if (isDisabled($element)) {
            return false;
        }

        if (isExpanded($element)) {
            collapse($element);
        } else {
            collapseAll({not: $element});
            expand($element);
            if($more.width() >= $body.width()) {
                $body.addClass('no-scroll');
            }
        }

        return false;
    };

    onHTMLClick = function onHTMLClick(event) {
        var $target = $(event.target);

        var $not = $target.parents('.expandable');
        if($target.hasClass('.expandable')) {
            $not.add($target);
        }

        collapseAll({not: $not});
    };

    bind = function bind() {
        $(document).ready(function () {
            $html.on('click', ':not(' + selector + ')', onHTMLClick);
            $html.on('click', selector, onExpandableClick);
        });
    };

    return {
        bind: bind,
        collapseAll: function () {
            collapseAll();
        }
    };
});
